const home = {
  "hero.badge": "ذكاء اصطناعي يتحدث مثلك",
  "hero.title.line1": "مساعدك الذكي،",
  "hero.title.line2": "متصل دائماً عبر واتساب",
  "hero.subtitle": "ردود ذكية ورسائل جماعية وتحليلات عميقة — منصة واحدة تدير كل محادثاتك باحترافية.",
  "hero.cta.getStarted": "ابدأ مجاناً",
  "hero.cta.viewPlans": "عرض الخطط",
  "hero.stat.messages": "الرسائل",
  "hero.stat.responseRate": "معدل الرد",
  "hero.chat.senderName": "سارة جونسون",
  "hero.chat.online": "متصل",
  "hero.chat.placeholder": "اكتب رسالة...",
  "hero.chat.msg1": "مرحباً! هل يمكن للذكاء الاصطناعي إدارة الرسائل الجماعية عبر واتساب؟",
  "hero.chat.msg2": "بالتأكيد! ندعم رسائل جماعية غير محدودة مع جدولة ذكية.",
  "hero.chat.msg3": "رائع! دعني أبدأ الإعداد فوراً.",
  "hero.scrollLabel": "انتقل للمميزات",
  "advantages.heading.badge": "لماذا تختارنا",
  "advantages.heading.title": "مميزات تميزنا عن غيرنا",
  "advantages.heading.subtitle": "كل تفصيلة مصممة لتقديم قيمة استثنائية. اكتشف ما يجعل خدمتنا الخيار المفضل.",
  "testimonials.badge": "ثقة العملاء",
  "testimonials.title.line1": "محبوب من الفرق",
  "testimonials.title.line2": "حول العالم",
  "cta.title": "مستعد للتحكم؟",
  "cta.subtitle": "ابدأ إدارة مميزاتك اليوم. البداية مجانية ويمكنك الترقية في أي وقت مع نمو أعمالك.",
  "cta.viewPlans": "عرض الخطط",
  "cta.talkToSales": "تحدث مع المبيعات",
  "advantages.item.0.title": "دعم متواصل 24/7",
  "advantages.item.0.description": "فريقنا المخصص متاح على مدار الساعة لحل أي مشكلة وضمان استمرارية أعمالك دون انقطاع.",
  "advantages.item.0.category": "الخدمة",
  "advantages.item.1.title": "أسعار شفافة",
  "advantages.item.1.description": "لا رسوم مخفية ولا مفاجآت. اعرف بالضبط ما تدفع مقابله مع هيكل تسعير واضح ومباشر.",
  "advantages.item.1.category": "التسعير",
  "advantages.item.2.title": "جودة متميزة",
  "advantages.item.2.description": "كل خدمة تُقدم باهتمام دقيق بالتفاصيل والتزام بأعلى معايير الجودة في المجال.",
  "advantages.item.2.category": "الجودة",
  "advantages.item.3.title": "إنجاز سريع",
  "advantages.item.3.description": "الوقت ثمين. عملياتنا المحسّنة تقدم نتائج أسرع بنسبة 40% من متوسط السوق دون المساس بالجودة.",
  "advantages.item.3.category": "الخدمة",
  "advantages.item.4.title": "حلول مخصصة",
  "advantages.item.4.description": "لا نؤمن بالحلول الموحدة. كل حل مصمم خصيصاً لتلبية احتياجات وأهداف عملك الفريدة.",
  "advantages.item.4.category": "الخدمة",
  "advantages.item.5.title": "أمن البيانات",
  "advantages.item.5.description": "تشفير بمستوى المؤسسات وامتثال لمعايير SOC 2 و GDPR و ISO 27001 للحفاظ على أمان بياناتك.",
  "advantages.item.5.category": "الجودة",
  "advantages.item.6.title": "خطط قابلة للتوسع",
  "advantages.item.6.description": "ابدأ صغيراً وانمُ بسلاسة. بنيتنا التحتية تتوسع مع أعمالك في كل مرحلة من مراحل النمو.",
  "advantages.item.6.category": "التسعير",
  "advantages.item.7.title": "ضمان الرضا",
  "advantages.item.7.description": "غير راضٍ؟ سنصحح الأمر. ضمان الرضا بنسبة 100% يضمن حصولك على القيمة التي تستحقها.",
  "advantages.item.7.category": "الخدمة",
  "advantages.item.8.title": "معتمدون في المجال",
  "advantages.item.8.description": "فريقنا يحمل أكثر من 50 شهادة مهنية ويواكب أحدث التوجهات والتقنيات باستمرار.",
  "advantages.item.8.category": "الجودة",
  "testimonials.item.0.name": "سارة المهدي",
  "testimonials.item.0.role": "المدير التنفيذي في هورايزون تك",
  "testimonials.item.0.quote": "التحول لهذه الخدمة كان أفضل قرار اتخذناه. الدعم المتواصل وحده وفر علينا ساعات لا تُحصى من التوقف.",
  "testimonials.item.1.name": "جمال الرشيدي",
  "testimonials.item.1.role": "مدير العمليات في سكيل أب",
  "testimonials.item.1.quote": "الأسعار الشفافة والحلول المخصصة تناسب احتياجاتنا تماماً. وجدنا أخيراً شريكاً يفهم طبيعة عملنا.",
  "testimonials.item.1.avatar": "JR",
  "testimonials.item.1.avatarColor": "bg-accent-100 text-accent-700",
  "testimonials.item.2.name": "إيمان الشمري",
  "testimonials.item.2.role": "مؤسسة برايت ويف",
  "testimonials.item.2.quote": "سرعة الإنجاز لديهم ليست مزحة. قلصنا وقت تسليم المشاريع بنسبة 35% منذ تعاملنا معهم.",
  "testimonials.item.2.avatar": "EC",
  "testimonials.item.2.avatarColor": "bg-secondary-100 text-secondary-700",
  "testimonials.item.3.name": "محمد الطويرقي",
  "testimonials.item.3.role": "المدير التقني في داتا فلو",
  "testimonials.item.3.quote": "أمن البيانات كان أهم أولوياتنا. امتثالهم للمعايير العالمية أعطانا الثقة لنقل كامل بنيتنا التحتية.",
  "testimonials.item.3.avatar": "MT",
  "testimonials.item.3.avatarColor": "bg-primary-100 text-primary-700",
  "testimonials.item.4.name": "ليلى القحطاني",
  "testimonials.item.4.role": "نائب رئيس التسويق في جروث لاب",
  "testimonials.item.4.quote": "ضمان الرضا ليس مجرد كلام تسويقي. تجاوزوا توقعاتنا بمراحل عندما احتجنا تعديلات.",
  "testimonials.item.4.avatar": "LP",
  "testimonials.item.4.avatarColor": "bg-accent-100 text-accent-700",
  "testimonials.item.5.name": "داود كريم",
  "testimonials.item.5.role": "رئيس المنتج في نيكسوس",
  "testimonials.item.5.quote": "الخطط القابلة للتوسع مكنتنا من البدء بما نحتاجه والنمو مع توسع قاعدة مستخدمينا. انتقال سلس تماماً.",
  "testimonials.item.5.avatar": "DK",
  "testimonials.item.5.avatarColor": "bg-secondary-100 text-secondary-700",

  // Industries / Categories
  "industries.badge": "حلول مخصصة للقطاعات",
  "industries.title": "مصمم لنمو أعمالك في كل مجال",
  "industries.subtitle": "سواء كنت تدير متجراً إلكترونياً أو عيادة أو شركة عقارية، Wyzon يمنحك الأتمتة التي تحتاجها لتسريع المبيعات وخدمة العملاء.",
  "industries.ecommerce.title": "المتاجر والتجارة الإلكترونية",
  "industries.ecommerce.desc": "استرجاع السلات المتروكة، تأكيد الطلبات، تتبع الشحن آلياً، والرد على أسئلة المنتجات 24/7.",
  "industries.clinics.title": "العيادات والمراكز الطبية",
  "industries.clinics.desc": "حجز المواعيد وتذكير المرضى تلقائياً، والرد على تكاليف الكشف وأوقات العمل بدون انتظار.",
  "industries.realestate.title": "العقارات والتطوير",
  "industries.realestate.desc": "تصنيف العملاء المحتملين آلياً، إرسال الكتالوجات والمخططات عبر واتساب، وتنسيق المعاينات فوراً.",
  "industries.services.title": "الشركات والخدمات",
  "industries.services.desc": "دعم فني مؤتمت، متابعة استفسارات B2B، وبناء سمعة احترافية بسرعة رد أقل من ثانية.",

  // FAQs for AEO & GEO
  "faq.badge": "الأسئلة الشائعة",
  "faq.title.line1": "كل ما تحتاج معرفته",
  "faq.title.line2": "عن منصة Wyzon",
  "faq.subtitle": "إجابات مباشرة على أكثر الأسئلة شيوعاً حول الأتمتة، الذكاء الاصطناعي، والربط مع واتساب وماسنجر.",
  "faq.item.0.q": "ما هي منصة Wyzon وكيف تساعد أعمالي؟",
  "faq.item.0.a": "منصة Wyzon هي نظام متكامل لإدارة وأتمتة محادثات واتساب وفيسبوك ماسنجر في صندوق وارد موحد، مع ذكاء اصطناعي فائق للرد الصوتي والنصي، وإرسال حملات جماعية ذكية بدون حظر لزيادة المبيعات بنسبة تصل إلى 98%.",
  "faq.item.1.q": "كيف تعمل المحادثات الموحدة (Omnichannel) بين واتساب وماسنجر؟",
  "faq.item.1.a": "تتيح لك Wyzon إدارة كل قنوات عملك (WhatsApp و Facebook Messenger) من واجهة واحدة متكاملة ومزامنة الرسائل لحظياً بالكامل عبر خوادم Meta الرسمية و Webhooks.",
  "faq.item.2.q": "هل يدعم النظام تفريغ وفهم التسجيلات الصوتية (Voice Notes) والرد عليها؟",
  "faq.item.2.a": "نعم! يدعم Wyzon تفريغ الفويس نوت بدقة فائقة باللغة العربية بلهجاتها المختلفة عبر الذكاء الاصطناعي، مع إمكانية الرد بصوت طبيعي احترافي أو نص مناسب فوراً.",
  "faq.item.3.q": "كيف تحمي Wyzon حسابي من الحظر أثناء إرسال الحملات الجماعية؟",
  "faq.item.3.a": "نستخدم خوارزميات ذكية للجدولة والتوزيع الزمني المتباعد بين الرسائل، مع صياغات ديناميكية متعددة للرسائل لتجنب قيود السبام والـ Rate Limits.",
  "faq.item.4.q": "هل أحتاج لأي خبرة برمجية للبدء؟",
  "faq.item.4.a": "إطلاقاً. المنصة مصممة بتقنية No-Code بالكامل مع إمكانية ربط حسابك في دقائق وتدريب الـ AI بملف CSV أو إعدادات بسيطة.",
  "faq.item.5.q": "هل تتوفر فترة تجريبية مجانية؟",
  "faq.item.5.a": "نعم، يمكنك البدء مجاناً واختبار كافة الميزات وربط قنواتك واستكشاف قوة الأتمتة قبل الترقية لأي باقة مدفوعة.",
};

export default home;